import { Story, PubstackDocument, PubstackRevision, Website } from '~/types'
import { Circulation } from './pubstack'
import { ComposerSettings, PicklistItem } from './settings'

interface WebskedTask {
  id: string
  authoringApp: string
}

export interface EllipsisReduxStore {
  appState: {
    canCirculateStory: boolean
    isOnline: boolean
    lockDetails: {
      isMyLock: boolean
      lockedBy: string | undefined
      lockedByDisplayName?: string
      readonly: boolean
    }
  }
  draftEditor: {
    toolboxSettings: unknown
  }
  storyData: {
    isValid: boolean
    validationMsg: string
    canonicalWebsite: undefined | string
    story: undefined | Story
    document?: PubstackDocument
    draftRevision?: PubstackRevision
    storyId?: string
    scheduleStatus: {
      publish: string | undefined
      unpublish: string | undefined
    }
    circulations: Circulation[]
  }

  // properties should be pre-defined in the initial state
  settings: Required<ComposerSettings>
  websked: {
    tasks: WebskedTask[]
  }
  tansa: {
    initialized: boolean
    loading: boolean
    error: unknown
  }
  route: {
    current: string
  }
  picklists: {
    data?: {
      picklists?: {
        [picklistKey: string]: {
          picklist?: PicklistItem[]
        }
      }
    }
  }
  // 'baseMetaTemplates' object from the angular metaTemplates service
  editorFields: {
    [fieldKey: string]: {
      label: string
      isValid?: () => boolean
      isIncomplete?: () => boolean
    }
  }
  websites: {
    [websiteId: string]: Website
  }
}
